import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteButtonsInterface,
  WebsiteButtonTypes,
  WebsiteFormFieldsSettings,
  WebsiteSettingsState,
  WebsiteSettingsTypographyTypeEnum,
  WebsiteThemeButtonsInterface,
} from '../../../shared/types/website-settings-types'

export const getWebsiteName = (state: WebsiteSettingsState) => state.websiteName

export const getWebsiteLocale = (state: WebsiteSettingsState) =>
  state.websiteLocale

export const getWebsiteLocales = (state: WebsiteSettingsState) =>
  state.websiteLocales

export const getWebsiteStyles = (state: WebsiteSettingsState) =>
  state.websiteStyles

export const getWebsiteStylesTypographyParagraph = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.typography?.paragraph

export const getWebsiteStylesTypographyHeading = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.typography?.heading

export const getWebsiteStylesPrimaryButtons = (state: WebsiteSettingsState) =>
  state.websiteStyles?.buttonsAndLinks?.primary

export const getWebsiteStylesSecondaryButtons = (state: WebsiteSettingsState) =>
  state.websiteStyles?.buttonsAndLinks?.secondary

export const getWebsiteStylesPrimaryButtonsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.buttonsAndLinks?.primary?.typography
export const getWebsiteStylesSecondaryButtonsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.buttonsAndLinks?.secondary?.typography

export const getWebsiteStylesFormFields = (state: WebsiteSettingsState) =>
  state.websiteStyles?.formFields

export const getWebsiteStylesFormFieldsTypography = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.formFields?.typography

export const getWebsiteStylesPrimaryButtonsBorder = (
  state: WebsiteSettingsState,
) => state.websiteStyles?.buttonsAndLinks?.primary?.border

export const getWebsiteThemesList = (state: WebsiteSettingsState) =>
  state.websiteThemesList

export const getWebsiteTheme = (state: WebsiteSettingsState) =>
  state.websiteTheme

export const getCurrentWebsiteTheme = (state: WebsiteSettingsState) =>
  state.websiteDraftTheme || state.websiteTheme

export const getWebsiteDraftTheme = (state: WebsiteSettingsState) =>
  state.websiteDraftTheme

export const buttonAndFormFieldSelectorMap: Record<
  WebsiteButtonAndFormFieldTypes,
  (
    state: WebsiteSettingsState,
  ) => Partial<WebsiteButtonsInterface | WebsiteFormFieldsSettings> | undefined
> = {
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]:
    getWebsiteStylesPrimaryButtons,
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]:
    getWebsiteStylesSecondaryButtons,
  [WebsiteSettingsTypographyTypeEnum.FormField]: getWebsiteStylesFormFields,
}

export const typographySelectorMap = {
  [WebsiteSettingsTypographyTypeEnum.Paragraph]:
    getWebsiteStylesTypographyParagraph,
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]:
    getWebsiteStylesPrimaryButtonsTypography,
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]:
    getWebsiteStylesSecondaryButtonsTypography,
  [WebsiteSettingsTypographyTypeEnum.FormField]:
    getWebsiteStylesFormFieldsTypography,
}

type WebsiteThemeButtonKeys = keyof WebsiteThemeButtonsInterface
interface ButtonColorKeysMapping {
  buttonTextColor: WebsiteThemeButtonKeys
  buttonBackgroundColor: WebsiteThemeButtonKeys
  hoveredButtonBackgroundColor: WebsiteThemeButtonKeys
  pressedButtonBackgroundColor: WebsiteThemeButtonKeys
}

export const buttonColorKeyMap: Record<
  WebsiteButtonTypes,
  ButtonColorKeysMapping
> = {
  [WebsiteSettingsTypographyTypeEnum.PrimaryButton]: {
    buttonTextColor: 'primaryButtonTextColor',
    buttonBackgroundColor: 'primaryButtonBackgroundColor',
    hoveredButtonBackgroundColor: 'primaryHoveredButtonBackgroundColor',
    pressedButtonBackgroundColor: 'primaryPressedButtonBackgroundColor',
  },
  [WebsiteSettingsTypographyTypeEnum.SecondaryButton]: {
    buttonTextColor: 'secondaryButtonTextColor',
    buttonBackgroundColor: 'secondaryButtonBackgroundColor',
    hoveredButtonBackgroundColor: 'secondaryHoveredButtonBackgroundColor',
    pressedButtonBackgroundColor: 'secondaryPressedButtonBackgroundColor',
  },
  // [WebsiteSettingsTypographyTypeEnum.GhostButton]: {
  //   buttonTextColor: 'ghostButtonTextColor',
  //   buttonBackgroundColor: 'ghostHoveredButtonBackgroundColor',
  //   hoveredButtonBackgroundColor: 'ghostHoveredButtonBackgroundColor',
  //   pressedButtonBackgroundColor: 'ghostPressedButtonBackgroundColor',
  // },
}
export const getWebsiteId = (state: WebsiteSettingsState) => state.websiteId

// @TODO discuss domains
// biome-ignore lint/correctness/noUnusedFunctionParameters: discuss domains
export const getWebsiteDomain = (state: WebsiteSettingsState) =>
  'domain.placeholder.com'

export const websiteSettingsSelectors = {
  getWebsiteId,
}
